export default __webpack_public_path__ + "static/vos-sadiya-4bd4dc02f8c10c19a380d6c9d92d9f80.mp4";